import controller from './wf-observations.controller';
import template from './wf-observations.html';
import './wf-observations.scss';

export default {
	controller,
	template,
	bindings: {
		observations: '<ngModel',
		disabled:     '<ngDisabled',
		options:      '<?',
	},
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
